module.exports = __webpack_public_path__ + "img/image-input-clear-button.dc76be35.svg";